export const Days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function getFriendlyGameDate(date, includeYear = false) {
    date = new Date(date);

    const day = Days[date.getDay()];
    const month = Months[date.getMonth()];

    return day + ", " + month?.substring(0, 3) + " " + date.getDate();
}

export function getFriendlyDate(date) {
    if (date === 'LATEST') {
        date = new Date();
    } else {
        date = new Date(date);
    }
    const month = Months[date.getMonth()];
    if (month) {
        return month.substring(0, 3) + " " + date.getDate();
    }
    return '';
}

export const formatGameTime = (date) => {
    if (date === 'LATEST') {
        date = new Date();
    } else {
        date = new Date(date);
    }
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    const strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}


export const formatDateForBrowsers = (date) => {
    let newDate = date;
    if (typeof date === 'undefined') {
        newDate = new Date();
    } else {
        newDate = date.replace(/-/g, "/")
    }
    return newDate
}

